import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../TierProductCardDumb/utils';
import s from './TierPricePerMonth.scss';
/* {price}/month typography */
var TierPricePerMonth = function (_a) {
    var price = _a.price, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("span", { className: classnames(s['root'], className) },
        React.createElement("span", { className: s['price'] }, formatPrice(price)),
        React.createElement("span", { className: s['period'] },
            "/",
            t('deviationview.tierCard.pricePeriod.month'))));
};
TierPricePerMonth.displayName = 'TierPricePerMonth';
export default TierPricePerMonth;
//# sourceMappingURL=TierPricePerMonth.js.map